import { render, staticRenderFns } from "./commodityPromotion.vue?vue&type=template&id=02355f90&scoped=true"
import script from "./commodityPromotion.vue?vue&type=script&lang=js"
export * from "./commodityPromotion.vue?vue&type=script&lang=js"
import style0 from "./commodityPromotion.vue?vue&type=style&index=0&id=02355f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02355f90",
  null
  
)

export default component.exports